import { isOurStorySection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { useTranslation } from 'next-i18next';
import { SectionContainer } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/section-container';
import {
  BodyText,
  Header2,
} from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/typography';
import { useWeddingWebsiteData } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/data/data-context';

export const OurStory = () => {
  const { t } = useTranslation('weddingWebsite');
  const { website } = useWeddingWebsiteData();
  const ourStory = website.sections.find(isOurStorySection);
  return (
    <SectionContainer detailsSectionId="ourStory" previewSectionId="ourStory">
      <Header2>{t('previewMode.tile.ourStory.title')}</Header2>
      <BodyText>{ourStory?.data.value}</BodyText>
    </SectionContainer>
  );
};
